import { Link } from "@phosphor-icons/react";
import NextLink from "next/link";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import toast from "react-hot-toast";
import useAuth from "@/hooks/auth";
import { useRouter } from "next/router";

export default function ShareButtons({ url, title, description }) {
  const { user } = useAuth();
  const router = useRouter();
  const buttonDisabled = user === null || user === undefined;
  const currentPath = router.asPath;

  const copyUrl = async function () {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("URL copied!");
    } catch (error) {
      console.log("Error", error);
      toast.error("Cannot copy the URL!");
    }
  };

  const goToLogin = () => {
    router.push(`/auth/login?redirect_to=${currentPath}`);
  };

  return (
    <div className='relative flex items-center space-x-1'>
      <FacebookShareButton
        url={url + "?utm_source=facebook&utm_medium=social"}
        quote={title + " - " + description}
        className='disabled:cursor-not-allowed'
      >
        <FacebookIcon
          size={24}
          round
          iconFillColor={"#171523"}
          bgStyle={{ fill: "#FFFFFF" }}
          className='duration-300 ease-out opacity-60 hover:opacity-100 disabled:cursor-not-allowed'
        />
      </FacebookShareButton>
      <TwitterShareButton
        url={url + "?utm_source=twitter&utm_medium=social"}
        title={title}
        className='inline-flex items-center disabled:cursor-not-allowed'
      >
        <div className='inline-flex items-center justify-center w-6 h-6 duration-300 ease-out rounded-full bg-white/60 text-background hover:bg-white/100'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-3.5 duration-300 ease-out disabled:cursor-not-allowed'
            viewBox='0 0 24 24'
          >
            <path
              fill='currentColor'
              d='M18.205 2.25h3.308l-7.227 8.26l8.502 11.24H16.13l-5.214-6.817L4.95 21.75H1.64l7.73-8.835L1.215 2.25H8.04l4.713 6.231l5.45-6.231Zm-1.161 17.52h1.833L7.045 4.126H5.078L17.044 19.77Z'
            />
          </svg>
        </div>
      </TwitterShareButton>
      <LinkedinShareButton
        url={url + "?utm_source=linkedin&utm_medium=social"}
        title={title}
        summary={description}
        className='disabled:cursor-not-allowed'
      >
        <LinkedinIcon
          size={24}
          round
          iconFillColor={"#171523"}
          bgStyle={{ fill: "#FFFFFF" }}
          className='duration-300 ease-out opacity-60 hover:opacity-100 disabled:cursor-not-allowed'
        />
      </LinkedinShareButton>
      <button
        onClick={copyUrl}
        className='flex items-center justify-center w-6 h-6 duration-300 ease-out bg-white rounded-full opacity-60 hover:opacity-100 disabled:opacity-40 disabled:cursor-not-allowed'
      >
        <Link legacyBehavior size={14} color='#171523' weight='bold' />
      </button>
    </div>
  );
}
